import React, { Suspense, useState } from 'react';
// import Navbar from '../navbar/Navbar';
import AdminNav from '../navbar/AdminNav';
import { Outlet } from 'react-router-dom';
// import AdminHome from '../pages/AdminPannel/dashboard/Dashboard';
// import AdminHome from '../home/AdminHome';
import TopBar from '../navbar/TopNav'
function AdminLayout() {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    const collapseSidenav = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed)
    }
    return (
        <div className='d-flex h-[100vh]'>
            <AdminNav isSidebarCollapsed={isSidebarCollapsed} />
            <div
                style={{
                    width: "100%",
                    transition: 'width 0.3s ease',
                    overflow: 'hidden',
                    backgroundColor: '#EFF6FF',

                }}>
                <TopBar collapseSidenav={collapseSidenav} />
                <Suspense fallback={<div className="p-6 text-center text-slate-600">Loading page…</div>}>
                    <Outlet />
                </Suspense>
            </div>
        </div>
    )
}

export default AdminLayout
